export class AdminData  {

    constructor(
        public id?: number,
        public email?: string,
        public phone?: string,
        public email_verify?: Number,
        public phone_verify?: Number,
        public name?: string,
        public lastname?: string,
        public created_at?: string,
        public updated_at?: string,
    ) {

    }

    public isLogged() {
        return !!this.id;
    }

    public setData(data: any) {
        this.id = data?.id;
        this.email = data?.email;
        this.phone = data?.phone;
        this.email_verify = data?.email_verify;
        this.phone_verify = data?.phone_verify;
        this.name = data?.name;
        this.lastname = data?.lastname;
        this.created_at = data?.created_at;
        this.updated_at = data?.updated_at;
    }

}